import { useQuery } from "@tanstack/react-query";
import { api } from "../api";
import type { EventLink } from "@shared/eventLinks";

export type PublicEventAudienceFilter = {
  ageMin?: number;
  ageMax?: number;
  genders?: string[];
  orientations?: string[];
};

export type PublicHostGroup = {
  id: string;
  slug: string;
  name: string;
  description: string | null;
  imageUrl: string | null;
  tags: string[];
};

export type PublicEventResponse = {
  slug: string;
  name: string | null;
  description: string | null;
  date: string;
  time: string;
  endTime: string | null;
  types: string[];
  posterLabel: string;
  visibility: string;
  coverImageUrl: string | null;
  links: EventLink[];
  audienceFilter: PublicEventAudienceFilter | null;
  addressRevealPolicy: "immediately" | "on_rsvp" | "hours_before";
  isPast: boolean;
  host: {
    id: string;
    firstName: string;
    lastName: string | null;
    profileImageUrl: string | null;
    group: PublicHostGroup | null;
  } | null;
  venue: {
    name: string;
    type: string;
    neighborhood: string | null;
    city: string | null;
    address?: string;
    lat?: number;
    lng?: number;
  } | null;
  capacity: number | null;
  priceCents: number | null;
  attendeeCount: number;
  interestedCount: number;
  spotsLeft: number | null;
  isRsvped: boolean;
  isInterested: boolean;
};

export function useEventPublic(slug: string | null) {
  return useQuery({
    queryKey: ["eventPublic", slug],
    queryFn: async () =>
      api.get<PublicEventResponse>(`/events/public/${slug}`),
    enabled: !!slug,
    retry: false,
  });
}
